import { render, staticRenderFns } from "./LaudoParceriaSustentavelRastreabilidade.vue?vue&type=template&id=082ff5f0&scoped=true&lang=pug"
import script from "./LaudoParceriaSustentavelRastreabilidade.vue?vue&type=script&lang=js"
export * from "./LaudoParceriaSustentavelRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./LaudoParceriaSustentavelRastreabilidade.vue?vue&type=style&index=0&id=082ff5f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082ff5f0",
  null
  
)

export default component.exports